export enum PaymentMethods {
    CREDITO = 'Tarjeta de crédito',
    DEBITO = 'Debito',
    EFECTIVO = 'Efectivo'
}